export default "__VITE_ASSET__HN95rqkf__"